/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import UpperFooterSlider from "../../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";

export default function Triptych() {
  return (
    <div className="Gallery-Wraps-2 retouching Canvases">
    <main>
      {/* hera banner start */}
      <div
        className="tp-breadcrumb__area fix tp-breadcrumb-height"
        data-background="assets/img/breadcrumb/Canvases.png"
        style={{
          backgroundImage: 'url("assets/img/breadcrumb/Canvases.png")',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="tp-breadcrumb__content text-center z-index-5">
                <h3 className="tp-breadcrumb__title">
                Triptych 
                </h3>
                <p className="w-100 b-heading">
                  That special place to make a statement. A special wall. In the entry or the living room. Canvas Splits redefines your art. Enhances the image to take on a spirit of its own.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* hero banner end */}
      {/* second content section start*/}
      <section className="parent">
        <section
          className=" pb-100 Partener photographs"
          data-background="assets/img/breadcrumb/routing.png"
          style={{ backgroundSize: "cover",backgroundImage:"url('assets/img/breadcrumb/routing.png')" }}
        >
          <div className="container">
            <div className="row ">
              <div className="row text text-center  ">
                <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                  {/* <h4 className="text-left second">
                  Create Your Triptych
                  </h4> */}
                  {/* <p className="w-100">
                  That special place to make a statement. A special wall. In the entry or the living room. Canvas Splits redefines your art. Enhances the image to take on a spirit of its own.
                  </p> */}
                </div>
              </div>
              <div
                className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                style={{ zIndex: 9 }}
              >
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/second-full-1.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="text-center mt-60 button-uper">
                <Link to={"/create-custom-print"} className="  large head banner">Create Triptych</Link>
                
              </div>
            </div>
          </div>
        </section>
      </section>
      {/* second content section end */}

<UpperFooterSlider/>

    </main>
  </div>
  );
}
